var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glyph",class:{ 'letter': !_vm.haveIcon }},[(_vm.haveIcon)?_c('icon-custom',{attrs:{"fill":"ui-bar","size":"xl","name":_vm.name}}):_c('p',{staticClass:"xs strong"},[_vm._v(_vm._s(_vm.abbreviation))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }